// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1FhZj","left":"StickyBox_left___Yqae","right":"StickyBox_right__UcTkS"};